import React, { Component } from 'react';
import { connect } from 'react-redux';
import Popper from '@material-ui/core/Popper';
import { ActionCreators as UndoActionCreators } from 'redux-undo'
import styled from 'styled-components'
import _ from 'lodash'

import { Button, Tooltip } from 'components'
import {ToolbarMenu, Notifications,Search, ShareOptions, AccessOptions} from 'features'
import { HistoryModule } from 'modules'
import {FaEllipsisH, FaArrowLeft, FaArrowRight, FaBell, FaShareAlt, FaSearch, FaLayerGroup} from "react-icons/fa";
import Toggle from '../Toggle/Toggle';

import classes from './Toolbar.module.css';
import * as actionCreators from 'store/actions/index';

const UndoRedo = styled.div`
    color: ${props => props.valid ? 'var(--secondary-accent2-color)' : 'var(--secondary-accent-color)'};
    font-size: 1rem;
    padding: 0 0.25rem 0 0.25rem;
    cursor: pointer;
    display: flex;
    align-items: center;
`

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

const ButtonsContainer = styled.div`
    display: flex;
    margin-right: 0.5rem;
`

class Toolbar extends Component {
    constructor (props) {
        super(props);
        this.state = {
            boundingClient: null,
            popper: false,
            popperElement: null,
        }
        this.buttonStyle = {
            backgroundColor: 'var(--primary-color)',
            margin: '0',
            padding: '0.5rem',
            borderColor: 'transparent',
            color: 'var(--text-color)'
        }
    }

    historyHandler = (type) => {
        if(this.props.canUndo && type === 'undo') {
            const past = _.last(this.props.history.past).data.toJS()
            this.props.timeTravel(type, past, this.props.history.present.data.toJS(),this.props.uid);
        } else if (this.props.canRedo && type === 'redo') {
            const future = _.head(this.props.history.future).data.toJS()
            this.props.timeTravel(type, future, this.props.history.present.data.toJS(),this.props.uid)
        }
    }

    render () {
        return (
            <div className={classes.Toolbar}>
                <Container>
                    <Toggle side={this.props.side} toggleHandler={this.props.setSide}/>
                    <Button styles={this.buttonStyle}
                        icon={<FaArrowLeft style={{filter: !this.props.canUndo && 'brightness(0.8)'}}/>}
                        tooltip={<div className={classes.Tooltip}><div>Undo</div><div className={classes.Code}>Ctrl+Z</div></div>} iconOnly
                        onSelect={() => this.historyHandler('undo')}/>
                    <Button styles={this.buttonStyle}
                        icon={<FaArrowRight style={{filter: !this.props.canRedo && 'brightness(0.8)'}}/>}
                        tooltip={<div className={classes.Tooltip}><div>Undo</div><div className={classes.Code}>Ctrl+Z</div></div>} iconOnly
                        onSelect={() => this.historyHandler('redo')}/>
                    <Button icon={<FaSearch/>} iconOnly
                        tooltip={<div className={classes.Tooltip}><div>Search</div><div className={classes.Code}>Ctrl+P</div></div>}
                        onSelect={() => {this.props.setModal(<Search/>, 'SEARCH')}} styles={this.buttonStyle}/>
                    
                    
                </Container>
                <ButtonsContainer>
                    <Button icon={<FaLayerGroup/>} iconOnly contextMenu={<AccessOptions/>} 
                        tooltip={<div className={classes.Tooltip}><div>Modules</div><div className={classes.Code}>Ctrl+B</div></div>}
                        placement='bottom' styles={this.buttonStyle}/>
                    {/* <Button icon={<FaShareAlt/>} iconOnly contextMenu={<ShareOptions/>} tooltip='Share' placement='bottom' styles={this.buttonStyle}/> */}
                    <Button icon={<FaBell/>} iconOnly contextMenu={<Notifications/>} tooltip='Notifications' placement='bottom' styles={this.buttonStyle}/>
                    <Button icon={<FaEllipsisH/>} iconOnly animation='default' tooltip='Options' contextMenu={<ToolbarMenu/>} placement='bottom-end' styles={this.buttonStyle}/>
                </ButtonsContainer>
            </div>
        );
    } 
};

const mapStateToProps = state => {
    return {
        history: state.db,
        canUndo: state.db.past.length > 0,
        canRedo: state.db.future.length > 0,
        data: state.db.present.data && state.db.present.data.toJS(),
        side: state.content.side,
        uid: state.auth.uid
    }
};

const mapDispatchToProps = dispatch => {
    return {
        timeTravel: (type,state,data,userId) => dispatch(actionCreators.timeTravel(type,state,data,userId)),
        onUndo: () => dispatch(UndoActionCreators.undo()),
        onRedo: () => dispatch(UndoActionCreators.redo()),
        setModal: (element, id) => dispatch(actionCreators.setModal(element, id)),
        setSide: (side) => dispatch(actionCreators.setSide(side))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Toolbar);